module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "pagecover",
    on: {
      "click": _vm.hide
    }
  }), _vm._v(" "), _c('v-header', {
    attrs: {
      "handleMenuButton": _vm.showOrHideMask,
      "show": _vm.show,
      "title": _vm.title
    }
  }), _vm._v(" "), _c('v-side-bar', {
    attrs: {
      "showSideBar": _vm.show,
      "toggleSideBar": _vm.showOrHideMask
    }
  }), _vm._v(" "), _c('v-list', {
    attrs: {
      "updateHeaderTitle": _vm.updateHeaderTitle,
      "array": _vm.listArray
    }
  }), _vm._v(" "), _c('v-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoading),
      expression: "showLoading"
    }]
  }), _vm._v(" "), _c('v-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3683a454"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 137
// module chunks = 1